import React from 'react';
import PropsType from 'prop-types';


const CheckBox = (props) => {

    let styleCheckBox = {
        width: '20px',
        minHeight: '20px',
        border: '2px solid black',
        borderRadius: '3px',
        boxShadow: '4px 3px 5px rgba(0,0,0,0.5)',
        cursor: 'pointer'
    };

    if (props.customCss != null) {
        styleCheckBox = Object.assign({}, styleCheckBox, props.customCss)
    }

    return (
        <>
            {props.check ?
                <i className='fa fa-check text-success fa-lg animate__animated animate__fadeIn'
                   style={{cursor: 'pointer'}}
                   onClick={props.disabled != null ? !props.disabled ? props.changeValue : null : props.changeValue}/> :

            <div onClick={props.disabled != null ? !props.disabled ? props.changeValue : null : props.changeValue}
                 className='animate__animated animate__fadeIn' style={styleCheckBox}/>
            }
        </>
    )
};

export default CheckBox;

CheckBox.PropsType = {
    check: PropsType.bool.isRequired,
    customCss: PropsType.object,
    disabled: PropsType.bool,
    changeValue: PropsType.func

};
